import React from 'react';
import Lottie from 'react-lottie-wrapper';
import { useInView } from 'react-intersection-observer';
import { Box } from '@chakra-ui/react';
import * as animationData2 from '../../images/home6.json';

/** A component that holds the animation shown on the homepage */
const HomeAnimation = () => {
  const [ref, inView] = useInView({ delay: 1800 });
  const options = {
    loop: true,
    autoplay: true,
    animationData: animationData2.default,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
      progressiveLoad: true,
    },
    renderer: 'svg',
  };

  return (
    <Box maxWidth="maxWidth" minHeight={['189px', '293px', '469px']} ref={ref}>
      <Lottie options={options} isStopped={!inView} aria-label={null} />
    </Box>
  );
};

export default HomeAnimation;
